import React from 'react';

function List({ children }) {
  return <dl className="divide-y divide-gray-100 dark:divide-border">{children}</dl>;
}

function Item({ children }) {
  return <div className="px-4 py-2 sm:grid sm:grid-cols-6 sm:gap-4 sm:px-0">{children}</div>;
}

function Term({ children }) {
  return (
    <dt className="text-sm font-medium leading-6 text-gray-900 dark:text-foreground col-span-2">
      {children}
    </dt>
  );
}

function Description({ children }) {
  return (
    <dd className="mt-1 text-sm leading-6 text-gray-700 dark:text-muted-foreground sm:col-span-4 sm:mt-0 space-y-2">
      {children}
    </dd>
  );
}

export const DescriptionList = { List, Item, Term, Description };
